// src/App.jsx
import React from "react";
import AppRoutes from "./routes";
import ToastContainer from "../shared/components/ToastContainer";
import SessionGuard from "core/auth/SessionGuard";

const App = () => {
  return (
    <SessionGuard>
      <AppRoutes />
      <ToastContainer />
    </SessionGuard>
  );
};

export default App;
